<template>
  <router-view/>
  <VueToaster richColors/>
</template>

<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
  name: 'App'
})
</script>